import React, { Component } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import { Font } from '../../../utils/fonts';

class Lable extends Component {
    constructor() {
        super();
        this.state = {
            isSingleDirection: false,
        };
    }

    componentDidMount() {
        this.checklocation();
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props;
        if (location.pathname !== prevProps.location.pathname) {
            this.checklocation();
        }
    }

    checklocation() {
        const { location, directions } = this.props;
        if (location.pathname !== '/') {
            if (directions.length === 1) {
                this.setState({ isSingleDirection: true });
            }
        }
    }

    render() {
        const { className, directions = [] } = this.props;
        const { isSingleDirection } = this.state;

        return (
            <Root className={className} isSingleDirection={isSingleDirection}>
                {
                    directions.map((direction, index) => (
                        <Direction
                            key={index.toString()}
                        >
                            {direction}
                        </Direction>
                    ))
                }
            </Root>
        );
    }
}

const Root = styled.div`
    display: ${({ isSingleDirection }) => (isSingleDirection ? 'none' : 'flex')};;
    flex-wrap: wrap;
`;

const Direction = styled.span`
    ${Font.REGULAR};
    font-size: 16px;
    line-height: 21px;
    color: rgba(0, 0, 0, .4);

    margin-right: 8px;

    :after {
        content: ',';
    }

    &:last-child {
            :after {
            content: '';
        }
    }
`;

export default withRouter(Lable);
